import { Star } from "lucide-react";
import { testimonials } from "@/data/landingData";

const TestimonialsSection = () => (
  <section className="py-16 sm:py-24">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-10 sm:mb-16">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          O Que <span className="text-gradient-green">Dizem</span>
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 max-w-5xl mx-auto">
        {testimonials.map((testimonial, index) => (
          <div key={testimonial.name} className="card-hover" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="flex items-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-primary text-primary" />
              ))}
            </div>
            <p className="text-sm sm:text-base text-muted-foreground mb-4 italic">"{testimonial.text}"</p>
            <div className="flex flex-wrap items-center justify-between gap-1">
              <span className="text-sm sm:text-base font-semibold">{testimonial.name}</span>
              <span className="text-xs sm:text-sm text-primary">{testimonial.persona}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
